import { Api as api } from "../api";
const prefix = "/master-data";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    vehicleTypeServiceV1ListTempTypes: build.query<
      VehicleTypeServiceV1ListTempTypesApiResponse,
      VehicleTypeServiceV1ListTempTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/temp-types` }),
    }),
    vehicleTypeServiceV1BatchCreateTempType: build.mutation<
      VehicleTypeServiceV1BatchCreateTempTypeApiResponse,
      VehicleTypeServiceV1BatchCreateTempTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/temp-types`,
        method: "POST",
        body: queryArg.vehicleTypeV1BatchCreateTempTypeReq,
      }),
    }),
    vehicleTypeServiceV1ListVehicleTypeCategories: build.query<
      VehicleTypeServiceV1ListVehicleTypeCategoriesApiResponse,
      VehicleTypeServiceV1ListVehicleTypeCategoriesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-type-categories` }),
    }),
    vehicleTypeServiceV1BatchCreateVehicleTypeCategory: build.mutation<
      VehicleTypeServiceV1BatchCreateVehicleTypeCategoryApiResponse,
      VehicleTypeServiceV1BatchCreateVehicleTypeCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-type-categories`,
        method: "POST",
        body: queryArg.vehicleTypeV1BatchCreateVehicleTypeCategoryReq,
      }),
    }),
    vehicleTypeServiceV1ListVehicleTypes: build.query<
      VehicleTypeServiceV1ListVehicleTypesApiResponse,
      VehicleTypeServiceV1ListVehicleTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-types`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          status: queryArg.status,
          temp_type_name: queryArg.tempTypeName,
          vehicle_type_name: queryArg.vehicleTypeName,
          vehicle_category_name: queryArg.vehicleCategoryName,
          created_by: queryArg.createdBy,
          updated_by: queryArg.updatedBy,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
      providesTags: ["VehicleType"],
    }),
    vehicleTypeServiceV1BatchCreateVehicleType: build.mutation<
      VehicleTypeServiceV1BatchCreateVehicleTypeApiResponse,
      VehicleTypeServiceV1BatchCreateVehicleTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-types`,
        method: "POST",
        body: queryArg.vehicleTypeV1BatchCreateVehicleTypeReq,
      }),
      invalidatesTags: ["VehicleType"],
    }),
    vehicleTypeServiceV1ActivateVehicleTypes: build.mutation<
      VehicleTypeServiceV1ActivateVehicleTypesApiResponse,
      VehicleTypeServiceV1ActivateVehicleTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-types/activate`,
        method: "PATCH",
        body: queryArg.vehicleTypeV1VehicleTypeBulkStatusChangeReq,
      }),
      invalidatesTags: ["VehicleType"],
    }),
    vehicleTypeServiceV1DeactivateVehicleTypes: build.mutation<
      VehicleTypeServiceV1DeactivateVehicleTypesApiResponse,
      VehicleTypeServiceV1DeactivateVehicleTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-types/deactivate`,
        method: "PATCH",
        body: queryArg.vehicleTypeV1VehicleTypeBulkStatusChangeReq,
      }),
      invalidatesTags: ["VehicleType"],
    }),
    vehicleTypeServiceV1GetVehicleTypeDropdown: build.query<
      VehicleTypeServiceV1GetVehicleTypeDropdownApiResponse,
      VehicleTypeServiceV1GetVehicleTypeDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-types/dropdown` }),
    }),
    vehicleTypeServiceV1GetVehicleType: build.query<
      VehicleTypeServiceV1GetVehicleTypeApiResponse,
      VehicleTypeServiceV1GetVehicleTypeApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/vehicle-types/${queryArg.id}` }),
    }),
    vehicleTypeServiceV1UpdateVehicleType: build.mutation<
      VehicleTypeServiceV1UpdateVehicleTypeApiResponse,
      VehicleTypeServiceV1UpdateVehicleTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-types/${queryArg.id}`,
        method: "PUT",
        body: queryArg.vehicleTypeServiceV1UpdateVehicleTypeBody,
      }),
      invalidatesTags: ["VehicleType"],
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as vehicleTypeApi };
export type VehicleTypeServiceV1ListTempTypesApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1ListTempTypesRes;
export type VehicleTypeServiceV1ListTempTypesApiArg = void;
export type VehicleTypeServiceV1BatchCreateTempTypeApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1TempTypeMessageRes;
export type VehicleTypeServiceV1BatchCreateTempTypeApiArg = {
  vehicleTypeV1BatchCreateTempTypeReq: VehicleTypeV1BatchCreateTempTypeReq;
};
export type VehicleTypeServiceV1ListVehicleTypeCategoriesApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1ListVehicleTypeCategoriesRes;
export type VehicleTypeServiceV1ListVehicleTypeCategoriesApiArg = void;
export type VehicleTypeServiceV1BatchCreateVehicleTypeCategoryApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1VehicleTypeCategoryMessageRes;
export type VehicleTypeServiceV1BatchCreateVehicleTypeCategoryApiArg = {
  vehicleTypeV1BatchCreateVehicleTypeCategoryReq: VehicleTypeV1BatchCreateVehicleTypeCategoryReq;
};
export type VehicleTypeServiceV1ListVehicleTypesApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1ListVehicleTypesRes;
export type VehicleTypeServiceV1ListVehicleTypesApiArg = {
  page?: number;
  size?: number;
  sortBy?: string;
  sortOrder?: string;
  status?: string;
  tempTypeName?: string;
  vehicleTypeName?: string;
  vehicleCategoryName?: string;
  createdBy?: string;
  updatedBy?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type VehicleTypeServiceV1BatchCreateVehicleTypeApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1VehicleTypeMessageRes;
export type VehicleTypeServiceV1BatchCreateVehicleTypeApiArg = {
  vehicleTypeV1BatchCreateVehicleTypeReq: VehicleTypeV1BatchCreateVehicleTypeReq;
};
export type VehicleTypeServiceV1ActivateVehicleTypesApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1VehicleTypeBulkStatusChangeRes;
export type VehicleTypeServiceV1ActivateVehicleTypesApiArg = {
  vehicleTypeV1VehicleTypeBulkStatusChangeReq: VehicleTypeV1VehicleTypeBulkStatusChangeReq;
};
export type VehicleTypeServiceV1DeactivateVehicleTypesApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1VehicleTypeBulkStatusChangeRes;
export type VehicleTypeServiceV1DeactivateVehicleTypesApiArg = {
  vehicleTypeV1VehicleTypeBulkStatusChangeReq: VehicleTypeV1VehicleTypeBulkStatusChangeReq;
};
export type VehicleTypeServiceV1GetVehicleTypeDropdownApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1GetVehicleTypeDropdownRes;
export type VehicleTypeServiceV1GetVehicleTypeDropdownApiArg = void;
export type VehicleTypeServiceV1GetVehicleTypeApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1VehicleTypeDetailRes;
export type VehicleTypeServiceV1GetVehicleTypeApiArg = {
  id: string;
};
export type VehicleTypeServiceV1UpdateVehicleTypeApiResponse =
  /** status 200 A successful response. */ VehicleTypeV1VehicleTypeMessageRes;
export type VehicleTypeServiceV1UpdateVehicleTypeApiArg = {
  id: string;
  vehicleTypeServiceV1UpdateVehicleTypeBody: VehicleTypeServiceV1UpdateVehicleTypeBody;
};
export type VehicleTypeV1TempTypeRes = {
  id?: string;
  name?: string;
};
export type VehicleTypeV1ListTempTypesRes = {
  temp_types?: VehicleTypeV1TempTypeRes[];
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type VehicleTypeV1TempTypeMessageRes = {
  message?: string;
};
export type VehicleTypeV1CreateTempTypeItem = {
  name: string;
};
export type VehicleTypeV1BatchCreateTempTypeReq = {
  items: VehicleTypeV1CreateTempTypeItem[];
};
export type VehicleTypeV1VehicleTypeCategoryRes = {
  id?: string;
  category_name?: string;
  has_temp_type?: boolean;
  has_chassis?: boolean;
  has_container?: boolean;
};
export type VehicleTypeV1ListVehicleTypeCategoriesRes = {
  vehicle_type_categories?: VehicleTypeV1VehicleTypeCategoryRes[];
};
export type VehicleTypeV1VehicleTypeCategoryMessageRes = {
  message?: string;
};
export type VehicleTypeV1CreateVehicleTypeCategoryItem = {
  category_name: string;
  has_temp_type?: boolean;
  has_chassis?: boolean;
  has_container?: boolean;
};
export type VehicleTypeV1BatchCreateVehicleTypeCategoryReq = {
  items: VehicleTypeV1CreateVehicleTypeCategoryItem[];
};
export type VehicleTypeV1VehicleTypeRes = {
  id?: string;
  category_id?: string;
  category_name?: string;
  vehicle_type?: string;
  temp_type_id?: string;
  temp_type_name?: string;
  is_chassis?: boolean;
  is_container?: boolean;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type VehicleTypeV1VehicleTypePaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type VehicleTypeV1ListVehicleTypesRes = {
  vehicle_types?: VehicleTypeV1VehicleTypeRes[];
  metadata?: VehicleTypeV1VehicleTypePaginationMeta;
};
export type VehicleTypeV1VehicleTypeMessageRes = {
  message?: string;
};
export type VehicleTypeV1CreateVehicleTypeItem = {
  category_id: string;
  vehicle_type: string;
  temp_type_id?: string;
  is_chassis?: boolean;
  is_container?: boolean;
  status: string;
};
export type VehicleTypeV1BatchCreateVehicleTypeReq = {
  items: VehicleTypeV1CreateVehicleTypeItem[];
};
export type VehicleTypeV1VehicleTypeBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type VehicleTypeV1VehicleTypeBulkStatusChangeReq = {
  ids: string[];
};
export type VehicleTypeV1VehicleTypeDropdownItemRes = {
  id?: string;
  name?: string;
  category?: string;
  is_add_on?: boolean;
};
export type VehicleTypeV1GetVehicleTypeDropdownRes = {
  vehicle_types?: VehicleTypeV1VehicleTypeDropdownItemRes[];
};
export type VehicleTypeV1VehicleTypeDetailRes = {
  id?: string;
  category_id?: string;
  category_name?: string;
  vehicle_type?: string;
  temp_type_id?: string;
  temp_type_name?: string;
  is_chassis?: boolean;
  is_container?: boolean;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type VehicleTypeServiceV1UpdateVehicleTypeBody = {
  vehicle_type: string;
};
export const {
  useVehicleTypeServiceV1ListTempTypesQuery,
  useVehicleTypeServiceV1BatchCreateTempTypeMutation,
  useVehicleTypeServiceV1ListVehicleTypeCategoriesQuery,
  useVehicleTypeServiceV1BatchCreateVehicleTypeCategoryMutation,
  useVehicleTypeServiceV1ListVehicleTypesQuery,
  useVehicleTypeServiceV1BatchCreateVehicleTypeMutation,
  useVehicleTypeServiceV1ActivateVehicleTypesMutation,
  useVehicleTypeServiceV1DeactivateVehicleTypesMutation,
  useVehicleTypeServiceV1GetVehicleTypeDropdownQuery,
  useVehicleTypeServiceV1GetVehicleTypeQuery,
  useVehicleTypeServiceV1UpdateVehicleTypeMutation,
} = injectedRtkApi;
